import { Injectable } from '@angular/core';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { OpzioniValidazioneIro } from '../doppia-materialita/doppia-materialita.service';
import { STDR } from '../standard-rendicontazione/standard-rendicontazione.service';
import { InformativaAziendaleWebService } from './informativa-aziendale-web.service';

export interface InformativaAziendale {
  titolo: string;
  /* status: string; */
  chiave: string;
  codiceLingua: string;
  descrizione: string;
  id: string;
  idInformativa: string;
  sezioni: Sezioni[];
  stato: string;
  versione: number;
  stdr?: STDR;
  compliance?: STDR;
  metadati?: any;
}

export interface Sezioni {
  chiave: string;
  descrizione: string;
  domande: Domande[];
  id: string;
  nomeBreve: string;
  punteggio: string;
  punteggioMaxOttenibile: string;
  punteggioPercentuale: string;
  titolo: string;
}

export interface Domande {
  chiave: string;
  domanda: string;
  lineaGuida: string;
  id: string;
  note: string;
  risposta: string | { valore?: string; um?: string };
  risposte: string[];
  data: number | Date; //long
  idCategoriaUnitaDiMisura: string;
  idUnitaDiRiferimento: string;
  obbligatorio: boolean;
  opzioni: Opzioni[];
  /**
   * solo per domande con tipo scelta_multipla_valore
   */
  opzioniConValore?: OpzioniValidazioneIro[];
  sottodomanda: boolean;
  tipo:
    | 'testo'
    | 'scelta_singola'
    | 'scelta_multipla'
    | 'scelta_multipla_valore'
    | 'numero_intero'
    | 'numero_decimale'
    | 'data';
  metadati: Metadati;
  dataUltimaModifica: string;
  moduloCompleto?: boolean;
}

export interface Metadati {
  tipo: string[];
  lineaGuida: string[];
  [key: string]: any;
}

export interface Opzioni {
  chiave: string;
  id: string;
  valore: string;

  /**
   * Solo per opzioni con valore testuale (domanda scelta multipla valore)
   */
  risposta?: string;

  /**
   * Solo per opzioni con valore numerico (domanda scelta multipla valore)
   */
  value?: string;

  /**
   * id delle sottodomande
   */
  sottodomande?: string[];
  moduloCompleto?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InformativaAziendaleService {
  public arrayTipologiaRisposta = [
    {
      chiave: 'scelta_singola',
      valore: 'Scelta Singola',
    },
    {
      chiave: 'scelta_multipla',
      valore: 'Scelta Multipla',
    },
    {
      chiave: 'testo',
      valore: 'Testo',
    },
    {
      chiave: 'numero_intero',
      valore: 'Numero',
    },
    {
      chiave: 'numero_decimale',
      valore: 'Decimale',
    },
    {
      chiave: 'data',
      valore: 'Data',
    },
  ];

  constructor(private readonly informativaAziendale: InformativaAziendaleWebService) {}

  /**
   * Funzione per selezionare le righe da far vedere nella grid
   * @param page pagina
   * @param pageSize record per pagina
   * @param ricerca risultato per ricerca
   * @param filters valori da filtrare
   * @param sortBy sort asc desc
   * @returns lista di righe
   */
  public get(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) {
    return this.informativaAziendale.get(page, pageSize, ricerca, filters, sortBy);
  }
  public getDomande(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) {
    return this.informativaAziendale.getDomande(page, pageSize, ricerca, filters, sortBy);
  }

  public getBozza(codiceSTDR?: string) {
    return this.informativaAziendale.getBozza(codiceSTDR);
  }

  /**
   * Funzine ws per la creazione del Ambito
   * @param data dati da inserire nel MongoDB
   * @returns chiama la funzione postAmbiti per la creazione Ambito
   */
  public post(data: any) {
    return this.informativaAziendale.post(data);
  }
  public postDomanda(domanda: Domande) {
    return this.informativaAziendale.postDomanda(domanda);
  }

  /**
   * Funzione per eliminare una riga da una lista
   * @param idRiga id della riga da eliminare
   * @returns
   */
  public delete(idRiga: any) {
    return this.informativaAziendale.delete(idRiga);
  }
  public deleteDomanda(idRiga: any) {
    return this.informativaAziendale.deleteDomanda(idRiga);
  }

  /**
   * Info Az
   * @param id
   * @param informazioni
   * @returns
   */
  public put(id: string, informazioni: any) {
    return this.informativaAziendale.put(id, informazioni);
  }

  public putDomanda(id: string, domanda: Domande) {
    return this.informativaAziendale.putDoamanda(id, domanda);
  }

  public putPubblica(id: string) {
    return this.informativaAziendale.putPubblica(id);
  }

  public getInformativaAziendaleEsterna(temporaryToken: string) {
    return this.informativaAziendale.getInformativaAziendaleEsterna(temporaryToken);
  }
  public getInformativaAziendaleEsternaVsme(temporaryToken: string) {
    return this.informativaAziendale.getInformativaAziendaleEsternaVsme(temporaryToken);
  }

  public putCompilaInformativaAziendaleEsterna(temporaryToken: string, informazioni: any) {
    return this.informativaAziendale.putCompilaInformativaAziendaleEsterna(
      temporaryToken,
      informazioni,
    );
  }
  public putCompilaInformativaAziendaleEsternaVsme(temporaryToken: string, informazioni: any) {
    return this.informativaAziendale.putCompilaInformativaAziendaleEsternaVsme(
      temporaryToken,
      informazioni,
    );
  }
  public putCompilaInformativaAziendaleEsternaBozza(temporaryToken: string, informazioni: any) {
    return this.informativaAziendale.putCompilaInformativaAziendaleEsternaBozza(
      temporaryToken,
      informazioni,
    );
  }
  public putCompilaInformativaAziendaleEsternaBozzaVsme(temporaryToken: string, informazioni: any) {
    return this.informativaAziendale.putCompilaInformativaAziendaleEsternaBozzaVsme(
      temporaryToken,
      informazioni,
    );
  }

  /**
   * Get lista stdr
   * @param settori
   * @returns
   */
  public getStdr(idInformativa: string | null, isCreazione: boolean) {
    return this.informativaAziendale.getStdr(idInformativa, isCreazione);
  }
}
